import { getDefaultCltOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/CltOverview/CltOverviewPageOne.defaults';
import { getDefaultCltOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/CltOverview/CltOverviewPageTwo.defaults';
import { getDefaultCrtOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/CrtOverview/CrtOverviewPageOne.defaults';
import { getDefaultCrtOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/CrtOverview/CrtOverviewPageTwo.defaults';
import { getDefaultDraftData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/Draft/Draft.defaults';
import { getDefaultChecklistData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/EstatePlanningChecklist/EstatePlanningChecklist.defaults';
import { getDefaultEstatePlanningGlossaryData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/EstatePlanningGlossary/EstatePlanningGlossary.defaults';
import { getDefaultEstateTaxesData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/EstateTaxesExplainer/EstateTaxesExplainer.defaults';
import { getDefaultFlpOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/FlpOverview/FlpOverviewPageOne.defaults';
import { getDefaultFlpOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/FlpOverview/FlpOverviewPageTwo.defaults';
import { getDefaultGratOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/GratOverview/GratOverviewPageOne.defaults';
import { getDefaultGratOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/GratOverview/GratOverviewPageTwo.defaults';
import { getDefaultGstExplainerData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/GstExplainer/GstExplainer.defaults';
import { getDefaultIdgtOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/IdgtOverview/IdgtOverviewPageOne.defaults';
import { getDefaultIlitOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/IlitOverview/IlitOverviewPageOne.defaults';
import { getDefaultIlitOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/IlitOverview/IlitOverviewPageTwo.defaults';
import { getDefaultInstallmentSaleOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/InstallmentSaleOverview/InstallmentSaleOverviewPageOne.defaults';
import { getDefaultInstallmentSaleOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/InstallmentSaleOverview/InstallmentSaleOverviewPageTwo.defaults';
import { getDefaultManagingInheritanceData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/ManagingRecentInheritance/ManagingRecentInheritance.defaults';
import { getDefaultNoEstatePlanningConsequencesData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/NoEstatePlanningConsequences/NoEstatePlanningConsequences.defaults';
import { getDefaultPhilanthropicPlanningData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/PhilanthropicPlanning/PhilanthropicPlanning.defaults';
import { getDefaultPopularStrategiesData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/PopularEstatePlanningStrategies/PopularEstatePlanningStrategies.defaults';
import { getDefaultQprtOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/QprtOverview/QprtOverviewPageOne.defaults';
import { getDefaultQprtOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/QprtOverview/QprtOverviewPageTwo.defaults';
import { getDefaultSettingUpPlanData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/SettingUpEstatePlan/SettingUpEstatePlan.defaults';
import { getDefaultSlatOverviewPageOneData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/SlatOverview/SlatOverviewPageOne.defaults';
import { getDefaultSlatOverviewPageTwoData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/SlatOverview/SlatOverviewPageTwo.defaults';
import { getDefaultStateTaxData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/StateInheritanceTaxExplainer/StateInheritanceTaxExplainer.defaults';
import { getDefaultTrustBasicsData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/TrustBasics/TrustBasics.defaults';
import { getDefaultWhyEstatePlanningMattersData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/WhyEstatePlanningMatters/WhyEstatePlanningMatters.defaults';
import { getDefaultWhyUseTrustData } from '@/modules/presentation/clientPresentation/components/slides/EducationalSlide/content/WhyUseTrust/WhyUseTrust.defaults';

import { DEFAULT_STATE_TAX_EDUCATION_SLIDES } from '../defaultSlides/StateTaxEducationSlides.defaults';
import {
  EducationListItemType,
  EducationSlideType,
  PlanningStrategiesSlideType,
  STATE_TAX_ITEMS,
  StateTaxEducationSlideType,
} from '../Education.constants';
import { DRAFT_SLIDE_ID } from '../Education.sentinels';

export function getEducationSlideDefaultData(
  slideId: EducationListItemType,
  slideIndex: number
) {
  // Why Estate Planning Matters
  if (slideId === EducationSlideType.WhyEstatePlanningMatters) {
    return getDefaultWhyEstatePlanningMattersData();
  }

  // No Estate Planning Consequences
  if (slideId === EducationSlideType.NoEstatePlanningConsequences) {
    return getDefaultNoEstatePlanningConsequencesData();
  }

  // Estate Taxes Explainer
  if (slideId === EducationSlideType.EstateTaxesExplainer) {
    return getDefaultEstateTaxesData();
  }

  // State Inheritance Tax Explainer
  if (slideId === EducationSlideType.StateInheritanceTaxExplainer) {
    return getDefaultStateTaxData();
  }

  if (STATE_TAX_ITEMS.includes(slideId as StateTaxEducationSlideType)) {
    return DEFAULT_STATE_TAX_EDUCATION_SLIDES[
      slideId as StateTaxEducationSlideType
    ];
  }

  // Managing Recent Inheritance
  if (slideId === EducationSlideType.ManagingRecentInheritance) {
    return getDefaultManagingInheritanceData();
  }

  // Estate Planning Glossary
  if (slideId === EducationSlideType.EstatePlanningGlossary) {
    return getDefaultEstatePlanningGlossaryData();
  }

  // Setting Up Estate Plan
  if (slideId === EducationSlideType.SettingUpEstatePlan) {
    return getDefaultSettingUpPlanData();
  }

  // Estate Planning Checklist
  if (slideId === EducationSlideType.EstatePlanningChecklist) {
    return getDefaultChecklistData();
  }

  // GST Explainer
  if (slideId === EducationSlideType.GstExplainer) {
    return getDefaultGstExplainerData();
  }

  // Why Use Trust
  if (slideId === PlanningStrategiesSlideType.WhyUseTrust) {
    return getDefaultWhyUseTrustData();
  }

  // Trust Basics
  if (slideId === PlanningStrategiesSlideType.TrustBasics) {
    return getDefaultTrustBasicsData();
  }

  // CLT
  if (slideId === PlanningStrategiesSlideType.Clt) {
    if (slideIndex === 0) {
      return getDefaultCltOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultCltOverviewPageTwoData();
    }
  }

  // CRT
  if (slideId === PlanningStrategiesSlideType.Crt) {
    if (slideIndex === 0) {
      return getDefaultCrtOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultCrtOverviewPageTwoData();
    }
  }

  // GRAT
  if (slideId === PlanningStrategiesSlideType.Grat) {
    if (slideIndex === 0) {
      return getDefaultGratOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultGratOverviewPageTwoData();
    }
  }

  // Popular Estate Planning Strategies
  if (slideId === PlanningStrategiesSlideType.PopularEstatePlanningStrategies) {
    return getDefaultPopularStrategiesData();
  }

  // Installment Sale
  if (slideId === PlanningStrategiesSlideType.InstallmentSaleLoan) {
    if (slideIndex === 0) {
      return getDefaultInstallmentSaleOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultInstallmentSaleOverviewPageTwoData();
    }
  }

  // ILIT
  if (slideId === PlanningStrategiesSlideType.Ilit) {
    if (slideIndex === 0) {
      return getDefaultIlitOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultIlitOverviewPageTwoData();
    }
  }

  // SLAT
  if (slideId === PlanningStrategiesSlideType.Slat) {
    if (slideIndex === 0) {
      return getDefaultSlatOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultSlatOverviewPageTwoData();
    }
  }

  // QPRT
  if (slideId === PlanningStrategiesSlideType.Qprt) {
    if (slideIndex === 0) {
      return getDefaultQprtOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultQprtOverviewPageTwoData();
    }
  }

  // IDGT
  if (slideId === PlanningStrategiesSlideType.Idgt) {
    return getDefaultIdgtOverviewPageOneData();
  }

  // FLP
  if (slideId === PlanningStrategiesSlideType.Flp) {
    if (slideIndex === 0) {
      return getDefaultFlpOverviewPageOneData();
    }
    if (slideIndex === 1) {
      return getDefaultFlpOverviewPageTwoData();
    }
  }

  // Philanthropic Planning
  if (slideId === PlanningStrategiesSlideType.PhilanthropicPlanning) {
    return getDefaultPhilanthropicPlanningData();
  }

  // Custom page draft
  if (slideId === DRAFT_SLIDE_ID) {
    return getDefaultDraftData();
  }

  return null;
}
